module.exports = __webpack_public_path__ + "img/thumb2.3bdf2d73.png";